import { useQuery } from "@tanstack/react-query";
import { useScopeParams } from "./useScopeParams";
import { insightsService } from "@/services/insightsService";
import type { SelectedSources } from "@/components/Chat/chat";

export type InsightExecution = {
  id: string;
  created_at: string;
  av_answer: string | null;
  av_explanation: string | null;
  selected_sources?: SelectedSources;
};

export const useInsightResultsQuery = (
  insightId?: string,
  enabled: boolean = true,
) => {
  const { id } = useScopeParams();

  const query = useQuery({
    queryKey: ["insight-results", id, insightId],
    queryFn: async (): Promise<InsightExecution[]> => {
      if (!id || !insightId) return [];
      return insightsService.getInsightResults(id, insightId);
    },
    enabled: enabled && !!id && !!insightId,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  return {
    executions: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
  };
};
